import { useQueryClient, type QueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { datXuLyHetPhien } from './api.js';

/**
 * Nối lớp làm mới phiên của `lib/api.ts` vào React.
 *
 * `goiApi` nằm **ngoài** React nên không gọi được hook: nó chỉ biết "phiên hết
 * hẳn rồi" và gọi một callback. Component này đăng ký callback đó, và vì nó
 * nằm trong `QueryClientProvider` + `BrowserRouter` nên làm được đủ hai việc
 * của một lượt đăng xuất sạch:
 *
 * 1. **dọn cache** — `qc.clear()`. Thiếu bước này thì người đăng nhập tiếp theo
 *    trên cùng tab thấy số của người trước nháy lên trước khi query mới về;
 * 2. **về màn đăng nhập** bằng router, không `window.location` — reload cả
 *    trang làm mất luôn thông báo lỗi mà người dùng cần đọc.
 *
 * Không render gì. Thân việc tách ra {@link taoXuLyHetPhien} để kiểm được mà
 * không phải dựng cả cây React.
 */
export function taoXuLyHetPhien(
  qc: Pick<QueryClient, 'clear'>,
  dieuHuong: (den: string, tuyChon: { replace: boolean }) => void | Promise<void>,
): () => void {
  return () => {
    qc.clear();
    void dieuHuong('/dang-nhap', { replace: true });
  };
}

export function PhienHetHan() {
  const qc = useQueryClient();
  const dieuHuong = useNavigate();

  useEffect(() => {
    datXuLyHetPhien(taoXuLyHetPhien(qc, dieuHuong));

    return () => {
      datXuLyHetPhien(null);
    };
  }, [qc, dieuHuong]);

  return null;
}
